module.exports = __webpack_public_path__ + "static/media/chatbot.4c939c03.svg";